import React from 'react';
import VideoPlaylistLabels from './properties/videoPlaylistLabels';

interface VideoCounterProps {
  current: number;
  total: number;
  labels: VideoPlaylistLabels;
}

const VideoCounter = (props: VideoCounterProps) => {
  const { current, total, labels } = props;
  const title = {
    __html: labels.title.replace('{0}', `<span>${current}</span>`).replace('{1}', `<span>${total}</span>`),
  };
  return (
    <div className="video-playlist__counter">
      <h4 className="hl-4 video-playlist__counter__headline" dangerouslySetInnerHTML={title} />
    </div>
  );
};

export default VideoCounter;
